// const bgStyle = {}
// // 要全局的变量的话
// bgStyle.width = '1920'
// bgStyle.height = '1080'
// bgStyle.marginLeft = 0

const  listOfPositions =  [
    {
        id: "1",
        fId: '1',
        title: "3D动作",
        tag: "美术/研发",
        tagId: 'fineArts',
        addr: "苏州",
        responsibilities: [
            "1. 负责游戏中的角色动作和剧情动画制作；",
            "2. 负责3D动作外包对接跟进；",
            "3. 保证动作的质量与进度，与团队其他组员保持良好的沟通。",
        ],
        requirements: [
            "1. 熟练使用Unity、Max。熟悉Unity引擎动画模块，参与过至少一个完整的项目开发；",
            "2. 能够根据角色的职业性格，设计出体现角色特征的动作；",
            "3. 动画理论基础扎实，对节奏、解剖学和运动规律有深入理解。有MMORPG游戏项目经验者优先。",
        ],
        fList:[]
    },
    {
        id: "2",
        fId: '1',
        title: "场景原画",
        tag: "美术/研发",
        tagId: 'fineArts',
        addr: "苏州",
        responsibilities: [
            "1. 根据游戏风格及规范绘制出高水准的游戏概念设计，负责游戏场景规划和设计场景建筑物件；",
            "2. 负责游戏宣传所需的场景设计。",
            "3. 能独立完成游戏概念设计、UI、2D角色场景等绘制；",
            "4. 与主美和策划方面能够进行良好的设计沟通。",
        ],
        requirements: [
            "1. 美术类相关专业，专科以上学历；",
            "2. 5年以上游戏原画场景设计工作经验，具备场景原画/概念设计经验；",
            "3. 绘画功底扎实，色彩感觉、光影感良好，具有较强的造型设计能力；想象力丰富，对各种建筑风格、结构及地形有深刻认识。",
            "4. 热爱游戏，对最新风格敏感；善于沟通、责任心强烈，能够主动承受工作压力和认真好学的工作态度。",
        ],
        fList:[]
    },
    {
        id: "3",
        fId: '2',
        title: "SDK接入（IOS）",
        tag: "技术",
        tagId: 'technology',
        addr: "上海",
        responsibilities: [
            "1. 负责基于平台游戏的 iOS SDK 的设计与开发。",
            "2. 负责游戏 SDK 各业务方介入的技术支持，例如：授权登录，支付，bug 跟踪，分享等。",
            "3. 负责与游戏 SDK 接入方的对接工作。",
        ],
        requirements: [
            "1. 熟悉  iOS 移动平台的开发，三年以上移动开发经验。",
            "2. 熟悉 Objective-C。",
            "3. 熟悉 Apple 支付流程，以及 Facebook 等常用第三方平台的 SDK 集成。",
            "4. 了解游戏渠道 SDK 接入。",
        ],
        fList:[
            '1. 有 SDK 开发经验优先。',
            '2. 了解多渠道打包更佳。',
            "3. 有修改第三方源码的经验。"
        ]
    },
    {
        id: "4",
        fId: '3',
        title: "日语运营经理",
        tag: "发行",
        tagId: 'issuance',
        addr: "上海",
        responsibilities: [
            "1、负责游戏日常运营及管理工作，为日本用户提供良好的游戏体验",
            "2. 完整的本地化经验。能无障碍面向日语用户以及合作伙伴。能帮助研发团队精确理解日语用户。",
            "3、用户侧：面向用户能梳理游戏运营流程，提高处理效率及玩家满意度",
            "4、 产品侧：面向产品研发团队能收集整理游戏运营数据，根据运营中出现的问题进行分析，及时输出分析报告及解决方案",
            "5、深度评测把控游戏质量，从用户侧到产品侧完成一整条流水线的产品输出。"
        ],
        requirements: [
            "1、熟悉日本文化，日语达到N1水平，有日本留学经历优先",
            "2、热爱游戏，，日服游戏经历者优先",
            "3、精通对应游戏设置，对产品有一定理解深度，具有一定的数据分析能力。",
            "4、参与过1-2款或以上日语区产品发行过程者优先",
        ],
        fList:[]
    },
    {
        id: "5",
        fId: '3',
        title: "高级数据分析",
        tag: "发行",
        tagId: 'issuance',
        addr: "上海",
        responsibilities: [
            "1、构建并完善游戏项目运营数据分析体系，并负责日常游戏相关业务的数据整理、统计、分析，撰写和汇总分析。",
            "2、针对游戏项目进行专项数据分析，包括并不限于用户价值、流失、游戏生态、活动版本效果、用户画像分析等，为运营决策、产品方向、销售策略提供数据支持。",
            "3、研究游戏的用户精细化运营，如用户画像的应用等。",
            "4、对产品、运营、市场提供数据分析支持。",
            "5、沉淀分析思路与框架， 提炼数据产品需求，数据技术与开发团队协作进行数据建模工作，推动完善游戏精细化运营数据分析体系；完成理念、技能储备，工具培训。"
        ],
        requirements: [],
        fList:[]
    },
    {
        id: "6",
        fId: '3',
        title: "韩语运营经理",
        tag: "发行",
        tagId: 'issuance',
        addr: "上海",
        responsibilities: [
            "1、负责游戏的版本跟踪和产品调优，与CP合作制定产品孵化方向与周期，对产品品质负责；",
            "2、与配合部门协调完善发行计划、各方资源，对上线结果负责；",
            "3、制定合理的运营计划，主导商业化活动；",
            "4、针对线上数据，结合游戏体验，对版本提出优化方向。",
        ],
        requirements: [
            "1、本科及以上学历，3年以上游戏行业 运营PM/活动策划 相关工作经验，能够独立应对运营各模块工作；",
            "2、对数据敏感，逻辑思维能力强，有较强的分析总结能力；",
            "3、细致主动，抗压性强，团队及跨部门合作沟通能力良好；",
            "4、有完整产品韩国发行运营上线经验者优先，会韩语优先",
            "5、有成功项目背景优先",

        ],
        fList:[]
    },
    {
        id: "7",
        fId: '1',
        title: "视频后期",
        tag: "美术",
        tagId: 'fineArts',
        addr: "上海",
        responsibilities: [
            "1.负责游戏视频（包含但不限于品宣视频、信息流投放视频、片头片尾）的策划和内容创意；",
            "2.对视频产品进行整体包装，使用户在观赏时有良好的视觉体验；",
            "3.负责部分视频的创意与策划，协调与沟通制作过程；",
            "4.有较好的文案功底，注重创新，具备视频脚本文案撰写能力，具备制作分镜头的能力。 ",
        ],
        requirements: [
            "1.熟练掌握视频编辑软件Pr、AE、C4D等相关视频与PS等平面软件，能自己编辑制作视频并具有包装能力 运营PM/活动策划 相关工作经验，能够独立应对运营各模块工作；",
            "2.富有创新精神；具有良好的美术功底与修养。",
            "3.热爱游戏并了解游戏文化，资深游戏玩家可作为加分项。",
            "4.有较强的学习能力和沟通能力，脑洞其大，灵性高及很强的团队协作精神，善于学习和分析，富有责任感。",
            "5.具备日韩或者欧美地区视频包装经验者优先。",

        ],
        fList:[]
    },
    {
        id: "8",
        fId: '1',
        title: "游戏动画师",
        tag: "美术",
        tagId: 'fineArts',
        addr: "上海",
        responsibilities: [
            "1、能够手动key 3Dmax动画，有调节过blendshapes经历；",
            "2、熟悉美术资产，能够对动作资产进行修改完善；",
            "3、制作游戏流量视频，对镜头和动作有所设计；",
            "4、熟悉了解UE4引擎，对Sequence模块有所接触 。     ",
        ],
        requirements: [
            "1、专科或专科及以上学历； ",
            "2、5年以上影视动画或游戏动画工作经验；",
            "3、熟练使用3Dmax和Maya，会使用3Dmax的CS骨骼及skin系统；",
            "4、有良好的动作设计基础，对于人物、动物肢体动作、运动节奏有较强理解能力，能够把握运动规律和发展趋势；",
            "5、有UE4工作经验，制作过流量视频者优先。",

        ],
        fList:[]
    },
    {
        id: "9",
        fId: '4',
        title: "资深海外广告投放优化师",
        tag: "市场",
        tagId: 'market',
        addr: "上海",
        responsibilities: [
            "1、熟悉Facebook、Google UAC、Tiktok等海外主流广告平台的合作流程、投放逻辑与操作。",
            "2、全面跟进广告投放工作，对投放数据负责，并独立完成输出数据分析报告。",
            "3、针对不同品类游戏、不同投放阶段提出明确的素材计划，并同美术部一同调整素材方向。",
            "4、根据不同地区和项目，负责规划和制定整体投放计划。",
            "5、负责优化师团队的管理，明确团队成员的任务安排和发展方向。",
            "6、负责竞品分析，并输出相关分析文档为投放和决策提供有效依据。",

        ],
        requirements: [
            "1、统招本科以上学历，至少2年以上海外主流投放平台操作经验及1年以上的优化师团队管理经验。 ",
            "2、有较强的逻辑思维能力和数据分析能力，对数字敏感，结果导向型。",
            "3、具备一定的创意能力，对素材有基于数据以外的独特见解。",
            "4、沟通能力强，协调优化师之间、二级部门之间和跨部门之间的业务往来。",
            "5、具备优秀的用户思维和较强抗压能力。",
            "6、日消耗超过10w美金，有欧美地区投放经验者优先。",
        ],
        fList:[]
    },
]


export default {
    listOfPositions
  }


// WEBPACK FOOTER //
// ./src/commonFunction/commonVal.js